module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-598.8082eac.woff2";